import { useSelector, useDispatch } from 'react-redux';
import { keyUpdatedAction } from '../../../../redux/actions/local';
import { getForms } from '../utils';
import {
  getFirestore,
  Timestamp,
  collection,
  getDocs,
  getDoc,
  doc,
  query
} from 'firebase/firestore';

const useExecute = () => {
  const user = useSelector(state => state.User);
  const dispatch = useDispatch();

  const executeFunction = async ({
    step,
    sequence,
    history,
    selections,
    documents,
    local,
    data,
    params
  }) => {
    if (step.executeCode?.trim().length > 0) {
      try {
        const forms = getForms();

        const setLocalStoreValue = async (key, value) => {
          dispatch(keyUpdatedAction(key, value));
        };

        const toDate = async value => {
          if (!value || !value.seconds) {
            return value;
          }
          const ts = new Timestamp(value.seconds, value.nanoseconds || 0);
          return ts.toDate();
        };

        const getDocument = async (path, id, databaseId) => {
          const db = getFirestore(databaseId);
          const docRef = doc(db, path, id);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            return docSnap.data();
          }
        };

        const getDocuments = async (path, databaseId) => {
          const db = getFirestore(databaseId);
          const querySnapshot = await getDocs(query(collection(db, path)));
          const docs = [];
          querySnapshot.forEach(doc => docs.push(doc.data()));
          return docs.filter(d => !d.deleted);
        };

        // eslint-disable-next-line
        const AsyncFunction = Object.getPrototypeOf(async function() {})
          .constructor;

        // eslint-disable-next-line
        const computeFunction = new AsyncFunction(
          'step',
          'sequence',
          'history',
          'selections',
          'documents',
          'local',
          'user',
          'forms',
          'data',
          'params',
          'setLocalStoreValue',
          'toDate',
          'getDocument',
          'getDocuments',
          step.executeCode
        );
        const value = await computeFunction(
          step,
          sequence,
          history,
          selections,
          documents,
          local,
          user,
          forms,
          data,
          params,
          setLocalStoreValue,
          toDate,
          getDocument,
          getDocuments
        );

        dispatch(
          keyUpdatedAction(
            step.computeLocalStoreKey || `result_step_${step.id}`,
            value
          )
        );

        if (local) {
          local[step.computeLocalStoreKey] = value;
        }

        return value;
      } catch (err) {
        return {
          error: `the step failed to run when attempting to execute the javascript function. The error was ${err.toString()}, step: ${
            step.name
          }`
        };
      }
    } else {
      return {
        error: `the step failed to run when attempting to execute the javascript function. no code was supplied.`
      };
    }
  };

  return {
    executeFunction
  };
};

export default useExecute;
